(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elastique-benefits-carousel"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var slides = document.querySelectorAll('.carousel-slide');
    var totalSlides = slides.length;

    function updateCarousel(newIndex) {
      // Hide all slides and show the new one
      slides.forEach(function (slide, index) {
        slide.style.display = index + 1 === newIndex ? 'block' : 'none';
      });
    }

    // Initialize the carousel to show the first slide
    updateCarousel(1);

    // Event listeners for navigation arrows
    document.querySelectorAll('.arrow').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var arrowDetails = this.id.split('-');
        var arrowType = arrowDetails[0];
        console.log(arrowType);
        var currentIndex = parseInt(arrowDetails[1], 10);
        console.log(currentIndex);
        var targetIndex;

        if (arrowType === 'next') {
          targetIndex = currentIndex === totalSlides ? 1 : currentIndex + 1;
        } else if (arrowType === 'prev') {
          targetIndex = currentIndex === 1 ? totalSlides : currentIndex - 1;
        }
        console.log(targetIndex);
        updateCarousel(targetIndex);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elastique-image-slider"]) return;
  try {
    
  var slider = document.getElementById('slider');
  var container = document.getElementById('comparison-container');
  var imageSecond = document.getElementById('image-second');
  var isDragging = false;

  slider.addEventListener('mousedown', function (e) {
    isDragging = true;
    e.preventDefault(); // Prevent default drag behavior
  });

  document.addEventListener('mouseup', function (e) {
    isDragging = false;
  });

  document.addEventListener('mousemove', function (e) {
    if (isDragging) {
      var rect = container.getBoundingClientRect();
      var x = e.pageX - rect.left;
      x = Math.max(0, Math.min(x, rect.width));
      sliderX = x - 26;
      slider.style.left = sliderX + 'px';
      imageSecond.style.width = x + 'px';
    }
  });

  // Add touch support for mobile devices
  slider.addEventListener('touchstart', function (e) {
    isDragging = true;
    e.preventDefault(); // Prevent default drag behavior on touch devices
  });

  document.addEventListener('touchend', function (e) {
    isDragging = false;
  });

  document.addEventListener('touchmove', function (e) {
    if (isDragging) {
      var touch = e.touches[0];
      var rect = container.getBoundingClientRect();
      var x = touch.pageX - rect.left;
      x = Math.max(0, Math.min(x, rect.width));
      sliderX = x - 26;
      slider.style.left = sliderX + 'px';
      imageSecond.style.width = x + 'px';
      e.preventDefault(); // Prevent scrolling when touching the slider
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1110px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
       // this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      // this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // window.addEventListener('scroll', this.onScrollHandler, false);

     // this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-hero-block"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
      let currentQuoteIndex = 0;
      let totalQuotes = parseInt(document.querySelector('.quote-text-block').dataset.totalQuotes);
      const quotes = document.querySelectorAll(".quote-text-block > div");

      function rotateQuotes() {
          // Add 'hidden' class to current visible quote
          quotes[currentQuoteIndex].classList.add('hidden');

          // Increment index or reset if at the end of the quotes
          if (currentQuoteIndex === quotes.length - 1) {
              currentQuoteIndex = 0;
          } else {
              currentQuoteIndex++;
          }

          // Remove 'hidden' class from the next quote
          quotes[currentQuoteIndex].classList.remove('hidden');
      }

      // Set the interval to rotate quotes every 5 seconds
      if (totalQuotes > 1) {
        setInterval(rotateQuotes, 5000);
      }
  });

  } catch(e) { console.error(e); }
})();
})();
